module.exports = __webpack_public_path__ + "static/media/01fa-prime.d0e3b845.jpg";